'use strict';

var exitListItem = require('./exitListItem');
var splitListItem = require('./splitListItem');

/**
 * User pressed Enter in an editor
 */
function onEnter(event, data, state, opts) {
    var startBlock = state.startBlock;

    // Pressing Shift+Enter
    // should split block normally

    if (data.isShift) {
        return;
    }

    // Block is empty, we exit the list
    if (startBlock.length === 0) {
        event.preventDefault();
        return exitListItem(state, opts);
    }

    // Split list item
    event.preventDefault();
    return splitListItem(state, opts);
}

module.exports = onEnter;


//////////////////
// WEBPACK FOOTER
// ./~/slate-edit-list/dist/onEnter.js
// module id = 676
// module chunks = 0